<script>
import gql from "graphql-tag";
import { locationMainFragment } from "@/graphql/location";
import { LocationTools } from "@/js/helper";
import BaseUpsertDialog from "./baseUpsertDialog.vue";

export default {
  name: "UpsertLocationDialog",
  extends: BaseUpsertDialog,
  props: { location: Object },

  data: function() {
    return {
      entityName: "location",
      name: {
        label: "Location Name",
        required: true
      },
      address: {
        label: "Address"
      },
      description: {
        label: "A Short description"
      },
      comments: {
        label: "Comments",
        multiline: true
      }
    };
  },

  computed: {
    dialogInputs: {
      get() {
        return [this.name, this.address, this.description, this.comments];
      }
    },
    currentUser: {
      get() {
        return this.$store.state.currentUser;
      }
    },
    entity: {
      get() {
        return this.location;
      }
    }
  },

  methods: {
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation($tinput: LocationInput!) {
              upsertLocation(location: $tinput) {
                ...LocationMain
              }
            }
            ${locationMainFragment}
          `,
          variables: {
            tinput: {
              id: this.location && this.location.id,
              name: this.name.value,
              description: this.description.value,
              comments: this.comments.value,
              address: this.address.value,
              isActive: true
            }
          }
        })
        .then(result => {
          const x = result.data.upsertLocation;
          this.$root.$emit("updateLocation", x.id);
          this.$store.commit(
            "setNotification",
            `${this.location ? "Updated" : "Created"} location ${x.name}`
          );
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to update location");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// upsertLocationDialog.vue?fe150fae